module.exports = __webpack_public_path__ + "img/logo-blue.329d23e3.svg";